import { isNil } from 'lodash-es';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import FolderIcon from 'images/icons/icon-folder.svg';
import SpecificationIcon from 'images/icons/icon-specification.svg';
import UnderlineButton from 'components/common/UnderlineButton';
import 'src/components/common/SpecificationFolderTile/SpecificationFolderTile.scss';
export const WarehouseReleaseSpecificationFolderTitle = ({ folder, isParentFolder, className, handleFolderRefresh, }) => {
    const { t } = useTranslation(['specification']);
    const handleRefresh = useCallback(() => {
        handleFolderRefresh(folder.id);
    }, [folder.id, handleFolderRefresh]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `FolderList w-auto ${className}`, style: { flex: '0 0 200px' } },
            React.createElement("div", { className: "Folder" },
                React.createElement("header", { className: "Folder__info" },
                    React.createElement("div", null,
                        !isNil(folder.foldersCount) && (React.createElement("div", { title: t('subfolders_count') },
                            React.createElement(FolderIcon, null),
                            React.createElement("span", null, folder.foldersCount))),
                        !isNil(folder.modelSpecificationsCount) && (React.createElement("div", { title: t('specifications_count') },
                            React.createElement(SpecificationIcon, null),
                            React.createElement("span", null, folder.modelSpecificationsCount))))),
                React.createElement(UnderlineButton, { className: "Folder__title mt-4 w-160 text-left text-ellipsis", onClick: handleRefresh, title: isParentFolder ? '..' : folder.name })))));
};
